var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransparency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9654 38.1277L50.9828 46.1451C52.2307 47.393 52.2307 49.416 50.9828 50.6638C49.735 51.9117 47.712 51.9117 46.4642 50.6638L40.0679 44.2676",
    stroke: "#D96122",
    strokeWidth: 2.73438,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0679 44.2675L45.7721 49.9716C47.0199 51.2195 47.0199 53.2425 45.7721 54.4903C44.5242 55.7382 42.5012 55.7382 41.2534 54.4903L37.144 50.381",
    stroke: "#D96122",
    strokeWidth: 2.73438,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.144 50.3809L39.6497 52.8866C40.8975 54.1344 40.8975 56.1574 39.6497 57.4053C38.4018 58.6531 36.3788 58.6531 35.131 57.4053L33.9599 56.2341M54.5347 20.4209L53.8567 20.7593C52.6489 21.362 51.3307 21.7113 49.983 21.7859C48.6353 21.8604 47.2865 21.6586 46.0197 21.1928C44.2298 20.5348 42.3193 20.2696 40.4179 20.4153C38.5165 20.561 36.6687 21.1142 35 22.0372L29.0489 25.3293C27.104 26.4051 26.5121 28.9244 27.7744 30.7539C28.7476 32.1641 30.5512 32.7381 32.1602 32.1493L39.655 29.4073C40.4483 29.1171 41.3081 29.0596 42.133 29.2418C42.9579 29.424 43.7135 29.8381 44.3108 30.4354L55.5017 41.6263C56.7495 42.8741 56.7495 44.8971 55.5017 46.145C54.2538 47.3928 52.2308 47.3928 50.983 46.145L42.1455 37.3075",
    stroke: "#D96122",
    strokeWidth: 2.73438,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 22.0374C33.3313 21.1143 31.4835 20.5611 29.5821 20.4154C27.6807 20.2697 25.7702 20.5349 23.9803 21.1931C22.7135 21.6588 21.3648 21.8606 20.017 21.7861C18.6693 21.7115 17.3511 21.3622 16.1433 20.7595L15.4913 20.4341M55.6641 41.4996L61.4682 38.4107M13.6886 40.9871L8.85446 37.1585M27.1524 44.8514L23.8014 48.2024M27.1524 44.8514C28.4002 43.6036 28.4002 41.5806 27.1524 40.3327C25.9045 39.0849 23.8815 39.0849 22.6337 40.3327L19.2827 43.6837C18.0349 44.9315 18.0349 46.9546 19.2827 48.2024C20.5305 49.4502 22.5535 49.4502 23.8014 48.2024M27.1524 44.8514C28.4002 43.6036 30.4232 43.6036 31.671 44.8514C32.9189 46.0992 32.9189 48.1223 31.671 49.3701L28.3201 52.7211C27.0722 53.9689 25.0492 53.9689 23.8014 52.7211C22.5535 51.4733 22.5535 49.4502 23.8014 48.2024",
    stroke: "#D96122",
    strokeWidth: 2.73438,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7711 55.3074L33.5903 56.4882C32.3425 57.7361 30.3194 57.7361 29.0716 56.4882C27.8238 55.2404 27.8238 53.2174 29.0716 51.9695L30.2524 50.7887C31.5003 49.5409 33.5233 49.5409 34.7711 50.7887C36.019 52.0365 36.019 54.0596 34.7711 55.3074ZM16.2554 37.6735L14.764 39.165C13.5162 40.4128 13.5162 42.4359 14.764 43.6837C16.0118 44.9315 18.0348 44.9315 19.2827 43.6837L20.7741 42.1922C22.022 40.9444 22.022 38.9214 20.7741 37.6735C19.5263 36.4258 17.5033 36.4258 16.2554 37.6735ZM68.6328 38.3223L62.6585 40.4714L53.4069 17.4591L64.2573 11.6587L68.6328 38.3223ZM1.36719 38.3223L7.34152 40.4714L16.5931 17.4591L5.74273 11.6587L1.36719 38.3223Z",
    stroke: "#D96122",
    strokeWidth: 2.73438,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparency);
export default __webpack_public_path__ + "static/media/transparency.937d0c9e036a79820a0446e65c22be37.svg";
export { ForwardRef as ReactComponent };